<!--
  All results: drawn at the rail's root, above both arms, the way Notes draws it (#1182 round 2c): a search
  lands every app on its search_results folder, and without this row Mail had nothing to show it selected
  or to get back to it. `searchResultsTeam` is the mailbox the search ran under, so the row is active by
  the shared rule and clicking it keeps that mailbox.
-->
@if (advancedSearchApplied) {
  <ng-container
    [ngTemplateOutlet]="navigationItem"
    [ngTemplateOutletContext]="{ item: searchResultsItem, index: 0, depth: 0, team: searchResultsTeam }"
  />
}

@if (!currentTeamWorkspace) {
  <div class="rail-private">
    @for (item of privateItems; track item.id; let index = $index) {
      <ng-container
        [ngTemplateOutlet]="navigationItem"
        [ngTemplateOutletContext]="{
          item: item,
          index: index + rootRowOffset,
          team: undefined,
          counts: myWorkspaceCounts,
        }"
      />
    }

    <div class="rail-divider"></div>
    <app-side-bar-folders
      [mailboxTenantId]="null"
      [messagesCount]="myWorkspaceCounts"
      (selectFilter)="selectFilter($event)"
      [team]="team"
    />

    <!-- Pinned Knots · Pinned Tags · Pinned Connections, as in every app's personal rail (Johanna, 2026-10-21;
         was Tags · Knots · Pinned Connections with a line between each). -->
    <div class="rail-divider"></div>
    <app-knowledge-items-rail [sidebarSplitViewKey]="SidebarSplitViewKey.mail" [team]="team" [withUnread]="true" />
  </div>
} @else {
  @if (currentMemberMailbox) {
    <section class="rail-section">
      <button
        type="button"
        class="rail-section-heading"
        [attr.aria-expanded]="myWorkspaceExpanded()"
        (click)="toggleSection(myWorkspaceExpanded)"
      >
        <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="myWorkspaceExpanded()" />
        My Workspace
      </button>

      @if (myWorkspaceExpanded()) {
        <div class="rail-section-content">
          @for (item of primaryItems; track item.id; let index = $index) {
            <ng-container
              [ngTemplateOutlet]="navigationItem"
              [ngTemplateOutletContext]="{
                item: item,
                index: index + rootRowOffset,
                team: currentMemberMailbox,
                counts: myWorkspaceCounts,
              }"
            />
          }

          <button
            type="button"
            class="rail-view-more"
            [attr.aria-expanded]="moreExpanded()"
            (click)="moreExpanded.set(!moreExpanded())"
          >
            <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="moreExpanded()" />
            View more
          </button>

          @if (moreExpanded()) {
            @for (item of moreItems; track item.id; let index = $index) {
              <ng-container
                [ngTemplateOutlet]="navigationItem"
                [ngTemplateOutletContext]="{
                  item: item,
                  index: index + primaryItems.length + rootRowOffset,
                  team: currentMemberMailbox,
                  counts: myWorkspaceCounts,
                }"
              />
              @if (item.id === 'snoozed') {
                <app-sidebar-item
                  data-testid="rail-row-following"
                  [title]="'Following'"
                  icon="bell"
                  [comingSoon]="true"
                  [depth]="0"
                  appSidebarContextMenu="following"
                  [appSidebarContextMenuTenantId]="currentMemberMailbox.id"
                  [appSidebarContextMenuRail]="true"
                  [appSidebarContextMenuOpenView]="openMemberView"
                />
              }
            }
          }

          <div class="rail-item-divider"></div>

          <app-side-bar-folders
            [depth]="0"
            [mailboxTenantId]="currentMemberMailbox.id"
            [messagesCount]="myWorkspaceCounts"
            (selectFilter)="selectFilter($event, currentMemberMailbox)"
            [team]="team"
            [memberRail]="true"
          />

          <div class="rail-item-divider"></div>

          <app-knowledge-items-rail
            [sidebarSplitViewKey]="SidebarSplitViewKey.mail"
            [tenantId]="currentMemberMailbox.id"
            [team]="currentMemberMailbox"
            [withUnread]="true"
          />
        </div>
      }
    </section>

    <div class="rail-divider"></div>
  }

  <app-sidebar-shared-placeholder />

  <div class="rail-divider"></div>

  <section class="rail-section">
    <button
      type="button"
      class="rail-section-heading"
      [attr.aria-expanded]="teamWorkspaceExpanded()"
      (click)="toggleSection(teamWorkspaceExpanded)"
    >
      <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamWorkspaceExpanded()" />
      Team Workspace
    </button>

    @if (teamWorkspaceExpanded()) {
      <div class="rail-section-content">
        <button
          type="button"
          class="rail-workspace-row"
          [attr.aria-expanded]="currentTeamWorkspaceExpanded()"
          (click)="toggleCurrentTeamWorkspace()"
        >
          <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="currentTeamWorkspaceExpanded()" />
          <span
            class="rail-workspace-avatar"
            [style.background-color]="workspaceColor(currentTeamWorkspace)"
            [style.color]="currentTeamWorkspace.color ? null : workspacePalette(currentTeamWorkspace).text"
          >
            {{ currentTeamWorkspaceInitials }}
          </span>
          <span class="rail-workspace-title">{{ currentTeamWorkspace.title }}</span>
        </button>

        @if (currentTeamWorkspaceExpanded()) {
          <div class="rail-team-workspace-content">
            @for (item of teamPrimaryItems; track item.id; let index = $index) {
              <ng-container
                [ngTemplateOutlet]="navigationItem"
                [ngTemplateOutletContext]="{
                  item: item,
                  index: index,
                  depth: 0,
                  team: currentTeamMailbox,
                  counts: teamCounts,
                }"
              />

              @if (index === 0) {
                <app-sidebar-item
                  data-testid="rail-row-assigned-to-me"
                  data-filter="assigned_to_me"
                  class="rail-navigation-item rounded"
                  [title]="'Assigned to me'"
                  icon="sapphire-user-plus"
                  [depth]="0"
                  [active]="currentTeamId === currentTeamMailbox?.id && sidebarFilter === 'assigned_to_me'"
                  (appClick)="selectFilter('assigned_to_me', currentTeamMailbox)"
                  appSidebarContextMenu="assigned_to_me"
                  [appSidebarContextMenuTenantId]="currentTeamMailbox?.id"
                  [appSidebarContextMenuRail]="true"
                  [appSidebarContextMenuRailScope]="'team'"
                />
              }
            }

            <button
              type="button"
              class="rail-view-more rail-team-view-more"
              [attr.aria-expanded]="teamMoreExpanded()"
              (click)="teamMoreExpanded.set(!teamMoreExpanded())"
            >
              <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamMoreExpanded()" />
              View more
            </button>

            @if (teamMoreExpanded()) {
              @for (item of teamMoreItems; track item.id; let index = $index) {
                <ng-container
                  [ngTemplateOutlet]="navigationItem"
                  [ngTemplateOutletContext]="{
                    item: item,
                    index: index,
                    depth: 0,
                    team: currentTeamMailbox,
                    counts: teamCounts,
                  }"
                />
                @if (item.id === 'snoozed') {
                  <app-sidebar-item
                    data-testid="rail-row-team-following"
                    data-filter="following"
                    [title]="'Following'"
                    icon="bell"
                    [depth]="0"
                    [active]="currentTeamId === currentTeamMailbox?.id && sidebarFilter === 'following'"
                    (appClick)="selectFilter('following', currentTeamMailbox)"
                    appSidebarContextMenu="following"
                    [appSidebarContextMenuTenantId]="currentTeamMailbox?.id"
                    [appSidebarContextMenuRail]="true"
                    [appSidebarContextMenuRailScope]="'team'"
                  />
                }
              }
            }
          </div>
        }

        <div class="rail-item-divider"></div>

        <app-side-bar-folders
          title="Team Folders"
          [depth]="0"
          [mailboxTenantId]="currentTeamWorkspace.id"
          [messagesCount]="teamCounts"
          (selectFilter)="selectFilter($event, currentTeamMailbox)"
          [team]="currentTeamMailbox"
          [teamRail]="true"
        />

        <div class="rail-item-divider"></div>

        <app-knowledge-items-rail
          knotsTitle="Team Knots"
          tagsTitle="Team Tags"
          [sidebarSplitViewKey]="SidebarSplitViewKey.mail"
          [tenantId]="currentTeamWorkspace.id"
          [team]="currentTeamMailbox"
          [depth]="0"
          [withUnread]="true"
        />
      </div>
    }
  </section>
}

<ng-template #navigationItem let-item="item" let-index="index" let-depth="depth" let-team="team" let-counts="counts">
  <!--
    data-tenant: the falsy check MUST come first. On the flat personal rail both `team` and
    `currentTeamMailbox` are undefined, so an identity test alone would label every personal row 'team'.
  -->
  @let rowActive = (currentTeamId ?? null) === (team?.id ?? null) && sidebarFilter === item.id;
  <!--
    My and Team Workspace rows draw the shared rail menu; the flat personal rail keeps the old one, except its Inbox,
    whose Mail volume menu is every login's (SBUX-1183).
  -->
  @let memberRow = !!team && team === currentMemberMailbox;
  @let teamRow = !!team && team === currentTeamMailbox;
  @let personalInbox = !team && item.id === 'inbox';

  <app-sidebar-item
    data-testid="rail-row"
    [attr.data-filter]="item.id"
    [attr.data-tenant]="!team ? 'personal' : team.id === currentTeamMailbox?.id ? 'team' : 'member'"
    class="rail-navigation-item rounded [&:not(.drag-over)]:hover:bg-hover"
    [class.drop-disabled]="isDragging && isDropBlocked(item.id)"
    [class.opacity-40]="isDragging && isDropBlocked(item.id)"
    [title]="item.title"
    [icon]="item.icon"
    [depth]="depth || 0"
    [active]="rowActive"
    (appClick)="selectFilter(item.id, team)"
    [appSidebarContextMenu]="item.id"
    [appSidebarContextMenuTenantId]="team?.id"
    [appSidebarContextMenuRail]="memberRow || teamRow || personalInbox"
    [appSidebarContextMenuRailScope]="teamRow ? 'team' : 'mine'"
    [appSidebarContextMenuOpenView]="
      memberRow ? openMemberView : teamRow ? openTeamView : personalInbox ? openPersonalView : undefined
    "
    #elRef
    appDroppable
    [appDroppableDisabled]="item.id === 'vip' || item.id === searchResultsItem.id"
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event, item.id, index)"
    (appDroppableEnter)="onItemDragEnter($event, item.id)"
    (appDroppableLeave)="onItemDragLeave(item.id)"
  >
    <!--
      The frame draws the unread number in the row's state colour, and the shared row projects it into
      an actions div that offers only Gray/700 (`text-icon-strong`) when selected, where the frame draws
      Gray/800. A colour set on the number itself beats the one it would inherit, and that adoption is
      mail's to make: the shared row is not this round's to edit. Inactive already inherits the frame's
      Gray/500 from `text-icon-light`.

      Rendered only when there IS a count, so an empty row does not add a flex child to the `gap-2`
      actions div and open a gap that shows on hover.

      `&ngsp;` keeps the space the plain interpolation used to leave between the label and the number in
      the row's text content. It draws nothing — a whitespace-only anonymous flex item is not rendered —
      but "My Inbox 14" stays one space apart for anything reading the row as text.
    -->
    <!--
      Every count is a plain number, in the row's own Gray/500, semibold while its page is open; the blue badges
      read too heavy, a 1,000 most of all (Johanna, 2026-10-22; Chat keeps its badges). No row marks its icon
      with a dot. Flagged shows no number: a count belongs to unread mail (and the Drafts and Scheduled totals),
      not to a marker (Johanna, 2026-10-21).
    -->
    @if (counts?.[item.id] && item.id !== 'flagged') {
      &ngsp;<span data-testid="rail-unread-count" class="rail-count">{{ counts[item.id] }}</span>
    }
    @if (memberRow && item.id === 'inbox' && accountKind.isTeam()) {
      <button
        type="button"
        data-testid="rail-inbox-options"
        class="rail-inbox-options"
        aria-label="My Inbox options"
        aria-haspopup="menu"
        title="Mail volume and Inbox options"
        appSidebarContextMenu="inbox"
        [appSidebarContextMenuTenantId]="team.id"
        [appSidebarContextMenuRail]="true"
        [appSidebarContextMenuRailScope]="'mine'"
        [appSidebarContextMenuOpenView]="openMemberView"
        stchPopoverTrigger="click"
        stchPopoverPlacement="bottomLeft"
      >
        <app-icon name="sapphire-chevron-down" size="s" />
      </button>
    }
    @if (teamRow && item.id === 'inbox' && accountKind.isTeam()) {
      <button
        type="button"
        data-testid="rail-team-inbox-options"
        class="rail-inbox-options"
        aria-label="Team Inbox options"
        aria-haspopup="menu"
        title="Mail volume and Inbox options"
        appSidebarContextMenu="inbox"
        [appSidebarContextMenuTenantId]="team.id"
        [appSidebarContextMenuRail]="true"
        [appSidebarContextMenuRailScope]="'team'"
        [appSidebarContextMenuOpenView]="openTeamView"
        stchPopoverTrigger="click"
        stchPopoverPlacement="bottomLeft"
      >
        <app-icon name="sapphire-chevron-down" size="s" />
      </button>
    }
  </app-sidebar-item>
</ng-template>

<ng-template #afterDropTemplate let-item="item">
  <app-message-quick-form
    [autofocus]="true"
    [showMore]="true"
    [title]="item.title"
    [message]="item"
    (more)="handleMore($event)"
    (close)="handleClose()"
    [transferredDraft]="true"
  />
</ng-template>
